import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import BarGraph from '../../../components/Portfolio/Charts/BarGraph/barGraph';
import Treemap from '../../../components/Portfolio/Charts/Treemap';
import {
  BarGraphContextLeft,
  BarGraphContextRight,
  BarGraphProviderLeft,
  BarGraphProviderRight,
} from './BarGraphs';
import { LineGraphs, MonetaryLineGraphProvider, ProductionLineGraphProvider } from './LineGraphs';
import TreemapContext, { TreemapProvider } from './Treemap/TreemapContext';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.palette.primaryBackground,
    height: '100%',
    width: '100%',
    padding: theme.spacing(2),
  },
}));

const PortfolioGraphing = ({ portfolios, consolidateAssetsProps }) => {
  const classes = useStyles();

  return (
    <Box
      gap={2}
      className={classes.root}
      display='grid'
      gridTemplateColumns='repeat(12, 1fr)'
      gridTemplateRows={{ xs: '1fr 1fr', sm: '1fr' }}
    >
      {/** biome-ignore lint/correctness/useUniqueElementIds: needed for the tutorial */}
      <Box
        id='portfolio-analysis-treemap'
        gridColumn={{ xs: 'span 12', sm: 'span 4', md: 'span 3' }}
      >
        <TreemapProvider portfolios={portfolios}>
          <Treemap context={TreemapContext} />
        </TreemapProvider>
      </Box>
      <Box
        display='grid'
        gridColumn={{ xs: 'span 12', sm: 'span 8', md: 'span 9' }}
        gap={2}
        gridTemplateColumns={{ xs: '1fr', md: 'repeat(2, 1fr)' }}
        gridTemplateRows={{ xs: 'repeat(4, 300px)', md: 'repeat(2, 1fr)' }}
      >
        <ProductionLineGraphProvider portfolios={portfolios}>
          <MonetaryLineGraphProvider portfolios={portfolios}>
            <LineGraphs portfolios={portfolios} consolidateAssetsProps={consolidateAssetsProps} />
          </MonetaryLineGraphProvider>
        </ProductionLineGraphProvider>
        {/** biome-ignore lint/correctness/useUniqueElementIds: needed for the tutorial */}
        <div id='portfolio-analysis-bar-graph'>
          <BarGraphProviderLeft portfolios={portfolios}>
            <BarGraph includeId context={BarGraphContextLeft} />
          </BarGraphProviderLeft>
        </div>
        <BarGraphProviderRight portfolios={portfolios}>
          <BarGraph context={BarGraphContextRight} />
        </BarGraphProviderRight>
      </Box>
    </Box>
  );
};

export default PortfolioGraphing;
